import { FC } from 'react';
import { OrderEvent } from '../../../../../server-types';
import TimelineMilestone from './TimelineMilestone';
import OrderLineDetails from './OrderLineDetails';
import OrderPaidCompletely from './OrderPaidCompletely';
import Dummy from './Dummy';
import {
    OrderCreated, PaidPartially, PaidCompletely, LinesAdded, MovedCompletely, CanceledCompletely, CanceledPartially, QuickSale, OrderClosed
} from '../../../../../types';


interface MapType {
    [OrderEvent.Created]: FC<OrderCreated | MovedCompletely | CanceledCompletely | OrderClosed>;
    [OrderEvent.PaidPartially]: FC<PaidPartially | LinesAdded | CanceledPartially | CanceledPartially>;
    [OrderEvent.PaidCompletely]: FC<PaidCompletely | QuickSale>;
    [OrderEvent.CanceledPartially]: FC<PaidPartially | LinesAdded | CanceledPartially | CanceledPartially>;
    [OrderEvent.OrderLinesMovedTo]: FC<PaidPartially | LinesAdded | CanceledPartially | CanceledPartially>;
    [OrderEvent.CanceledCompletely]: FC<OrderCreated | MovedCompletely | CanceledCompletely | OrderClosed>;
    [OrderEvent.MovedPartially]: FC<any>;
    [OrderEvent.MovedCompletely]: FC<OrderCreated | MovedCompletely | CanceledCompletely | OrderClosed>;
    [OrderEvent.QuickSale]: FC<PaidCompletely | QuickSale>;
    [OrderEvent.OrderLinesAdded]: FC<PaidPartially | LinesAdded | CanceledPartially>;
    [OrderEvent.MovedAndJoined]: FC<OrderCreated | MovedCompletely | CanceledCompletely | OrderClosed>;
}

export const eventTypeToComponentMap: MapType = {
    [OrderEvent.Created]: TimelineMilestone,
    [OrderEvent.PaidPartially]: OrderLineDetails,
    [OrderEvent.PaidCompletely]: OrderPaidCompletely,
    [OrderEvent.CanceledPartially]: OrderLineDetails,
    [OrderEvent.CanceledCompletely]: TimelineMilestone,
    [OrderEvent.MovedPartially]: Dummy,
    [OrderEvent.MovedCompletely]: TimelineMilestone,
    [OrderEvent.QuickSale]: OrderPaidCompletely,
    [OrderEvent.OrderLinesAdded]:OrderLineDetails,
    [OrderEvent.MovedAndJoined]: TimelineMilestone,
    [OrderEvent.OrderLinesMovedTo]: OrderLineDetails,
};
